/* global google */

const markers = [];
let container;
let mapEmbed;
let mapOptions;
let mapToRender;

const icons = {
    default: {
        icon: "map-marker-default.png",
        width: 61,
        height: 83,
    },
};

const mapMarkerListener = function mapMarkerListener(marker, i) {
    google.maps.event.addListener(
        marker,
        "click",
        function markerClickEvent() {
            if(mapOptions.markerUrl) {
                window.open(mapOptions.markerUrl, "_blank").focus();
            }
        },
    );
};

const createMapMarker = () => {
    const locationType = "default";
    const markerIcon = `${window.baseImagePath}/${icons[locationType].icon}`;
    const markerHeight = icons[locationType].height;
    const markerWidth = icons[locationType].width;

    const markerImage = {
        url: markerIcon,
        scaledSize: new google.maps.Size(markerWidth, markerHeight),
    };

    const marker = new google.maps.Marker({
        position: new google.maps.LatLng(mapOptions.centerLat, mapOptions.centerLng),
        icon: markerImage,
        map: mapToRender,
        optimized: false,
    });

    markers.push(marker);
};

const mapMarkers = () => {
    createMapMarker();

    // Add event listener to each marker.
    let j;
    for (j = 0; j < markers.length; j += 1) {
        mapMarkerListener(markers[j], j);
    }
};

const mapRender = () => {
    // Reduce landmarks to 'de-clutter' map of labels.
    // Settings: Road 4, Landmarks 3, Labels 4.
    // https://mapstyle.withgoogle.com/
    const mapTypeStyles = [
        {
            featureType: "poi.business",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "labels.text",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
    ];

    mapToRender = new google.maps.Map(mapEmbed, {
        zoom: parseInt(mapOptions.zoomDefault, 10),
        minZoom: parseInt(mapOptions.zoomMin, 10),
        maxZoom: parseInt(mapOptions.zoomMax, 10),
        center: new google.maps.LatLng(
            mapOptions.centerLat,
            mapOptions.centerLng,
        ),
        mapTypeId: "roadmap",
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: true,
        styles: mapTypeStyles,
        // Keep the POI icons but disable the infowindows.
        // https://stackoverflow.com/questions/7478069/disable-point-of-interest-information-window-using-google-maps-api-v3
        clickableIcons: false,
    });
};

const initMap = () => {
    // Bind elements
    mapEmbed = document.getElementsByClassName("js-map-embed")[0];

    mapOptions = {
        centerLat: mapEmbed.dataset.mapLatitude,
        centerLng: mapEmbed.dataset.mapLongitude,
        markerUrl: mapEmbed.dataset.mapMarkerUrl,
        zoomDefault: 12,
        zoomMin: 1, // Zoom out.
        zoomMax: 20, // Zoom in.
    };

    mapRender();
    mapMarkers();
};

const initApi = () => {
    if (typeof google === "undefined") {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${window.googleMapsApiKey}&libraries=places&callback=initMap&loading=async`;
        document.body.appendChild(script);
    } else {
        initMap();
    }
};

const MapEmbed = () => {
    container = document.querySelector("[data-map]");
    if (container === null) {
        return;
    }

    initApi();
};

window.initMap = initMap;

export default MapEmbed;
